module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-6@2x-d5d9b7b20c2e1049dfcd33fd4dd72e57.png";